import gql from "graphql-tag";

export const MY_HR_LAST_PASSWORD_CHANGE_SUBSCRIPTION = gql`
  subscription lastPasswordChange($email: String!) {
    lastPasswordChange(email: $email)
  }
`;
